<div class="map" id="map"></div>
<!--
<div 
     leaflet
     [leafletOptions]="mapOptions"
     (leafletMapReady)="onMapReady($event)"
     >
</div>
-->